import React from "react";
import styled, { keyframes } from "styled-components";


const backgroundFlash = keyframes`
  0% {
    background: rgba(255,255,0,1);
  }
  100% {
    background: rgba(0,0,0,0);
  }
`;

const textFade = keyframes`
  0% {
    color: rgba(255,255,0,1);
  }
  100% {
    color: rgba(255,255,255,1);
  }
`;

const StyledDiv=styled.div`
    margin-bottom:0.5em;
    animation: ${backgroundFlash} 100ms, ${textFade} 20s step-end;

`;

const StyledName=styled.span`
    font-weight:bold;
`;

const StyledMessage=styled.span`
`;

function ChatMessage(props) {
    return (
        <StyledDiv>
            <StyledName>{props.chat.nick_name}: </StyledName>
            <StyledMessage>{props.chat.message}</StyledMessage>
        </StyledDiv>
    );
}

export default ChatMessage;
